const Nav = () => (
  <nav className="fixed inset-x-0 top-0 z-50 border-b border-line bg-base/80 backdrop-blur">
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
      <a href="#top" className="font-mono text-lg font-semibold tracking-tight">
        techlyft<span className="text-accent">_</span>
      </a>
      <div className="flex items-center gap-5 font-mono text-xs uppercase tracking-widest sm:gap-8">
        <a href="#products" className="text-muted transition-colors hover:text-fg">
          Products
        </a>
        <a href="#approach" className="text-muted transition-colors hover:text-fg">
          Approach
        </a>
        <a href="#contact" className="text-muted transition-colors hover:text-fg">
          Contact
        </a>
      </div>
    </div>
  </nav>
);

export default Nav;
